import { createSelector } from '@base-ui/utils/store';
export const eventCalendarOccurrencePlaceholderSelectors = {
  placeholderInDayCell: createSelector((state, day, rowStart) => {
    if (state.occurrencePlaceholder === null || state.occurrencePlaceholder.surfaceType !== 'day-grid' || state.occurrencePlaceholder.isHidden) {
      return null;
    }
    if (state.adapter.isSameDay(day, state.occurrencePlaceholder.start)) {
      return state.occurrencePlaceholder;
    }
    if (state.adapter.isSameDay(day, rowStart) && state.adapter.isWithinRange(rowStart, [state.occurrencePlaceholder.start, state.occurrencePlaceholder.end])) {
      return state.occurrencePlaceholder;
    }
    return null;
  }),
  placeholderInTimeRange: createSelector((state, start, end) => {
    if (state.occurrencePlaceholder === null || state.occurrencePlaceholder.surfaceType !== 'time-grid' || state.occurrencePlaceholder.isHidden) {
      return null;
    }
    if (state.adapter.isBefore(state.occurrencePlaceholder.end, start) || state.adapter.isAfter(state.occurrencePlaceholder.start, end)) {
      return null;
    }
    return state.occurrencePlaceholder;
  }),
  isCreatingInDayCell: createSelector((state, day) => {
    const placeholder = state.occurrencePlaceholder;
    if (placeholder?.surfaceType !== 'day-grid' || placeholder.type !== 'creation') {
      return false;
    }
    return state.adapter.isSameDay(day, placeholder.start);
  }),
  isCreatingInTimeRange: createSelector((state, dayStart, dayEnd) => {
    const placeholder = state.occurrencePlaceholder;
    if (placeholder?.surfaceType !== 'time-grid' || placeholder.type !== 'creation') {
      return false;
    }
    if (!state.adapter.isSameDay(placeholder.start, dayStart)) {
      return false;
    }
    const startsBeforeEnd = state.adapter.isBefore(placeholder.start, dayEnd);
    const endsAfterStart = state.adapter.isAfter(placeholder.end, dayStart);
    return startsBeforeEnd && endsAfterStart;
  })
};